import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

export interface GridBoxesProps {
    height: number;
    width: number;
    margin: number;
    childrens: Array<any>;
}
export function GridBoxes(props: PropsWithChildren<GridBoxesProps>) {
    const { height, width, margin, childrens } = props;
    const w = width + 2 * margin;
    const h = height + 2 * margin;
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(auto-fill,${w}px)`,
                gridTemplateRows: `repeat(auto-fill,${h}px)`,
                justifyContent: "center",
                width: "100%",
            }}
        >
            {childrens.map((content, index) => {
                return (
                    <Box
                        sx={{
                            margin: margin.toString() + "px",
                            width: width.toString() + "px",
                            height: height.toString() + "px",
                        }}
                        key={index}
                    >
                        {content}
                    </Box>
                );
            })}
        </Box>
    );
}
